import { render, staticRenderFns } from "./RenameWatchlistModal.vue?vue&type=template&id=e45d4a48&scoped=true"
import script from "./RenameWatchlistModal.vue?vue&type=script&lang=js"
export * from "./RenameWatchlistModal.vue?vue&type=script&lang=js"
import style0 from "./RenameWatchlistModal.vue?vue&type=style&index=0&id=e45d4a48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45d4a48",
  null
  
)

export default component.exports